module.exports = __webpack_public_path__ + "img/service4.830fb87a.png";